import { render, staticRenderFns } from "./publicCourses.vue?vue&type=template&id=c51d974c&scoped=true&"
import script from "./publicCourses.vue?vue&type=script&lang=js&"
export * from "./publicCourses.vue?vue&type=script&lang=js&"
import style0 from "./publicCourses.vue?vue&type=style&index=0&id=c51d974c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51d974c",
  null
  
)

export default component.exports